// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { LoadingStatus, ProjectDetail, Loadable, MaybeLoadable } from '@app/core/models';
import { ProjectsActionsUnion, ProjectsActionTypes } from './projects.actions';

export interface ProjectsState {
  [key: string]: ProjectDetail | Loadable;
}

export function projectsReducer(
  state: Readonly<ProjectsState> = {},
  action: ProjectsActionsUnion
): Readonly<ProjectsState> {
  switch (action.type) {
    case ProjectsActionTypes.PROJECT_DETAILS_LOADING:
      return {
        ...state,
        [action.payload.projectId]: {
          status: LoadingStatus.LOADING
        }
      };

    case ProjectsActionTypes.PROJECT_DETAILS_LOAD_COMPLETE:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          ...action.payload,
          status: LoadingStatus.LOAD_COMPLETE
        }
      };

    case ProjectsActionTypes.PROJECT_DETAILS_LOAD_FAILED:
      return {
        ...state,
        [action.payload.projectId]: {
          ...state[action.payload.projectId],
          status: LoadingStatus.LOAD_FAILED
        }
      };
  }
  return state;
}

export function getProjectDetails(projectId: string): (state: ProjectsState) => ProjectDetail | MaybeLoadable {
  return (state: ProjectsState) => state[projectId];
}



// WEBPACK FOOTER //
// ./src/app/core/state/projects.reducer.ts